import React from "react";

const TopicContentIcon = ({fill}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.279"
      height="40.646"
      viewBox="0 0 33.279 40.646"
    >
      <g id="ft-2" transform="translate(-125 -96)">
        <path
          id="Path_40"
          data-name="Path 40"
          d="M232.958,96H213.27A1.274,1.274,0,0,0,212,97.27v27.055a1.274,1.274,0,0,0,1.27,1.27h19.688a1.274,1.274,0,0,0,1.27-1.27V97.27A1.274,1.274,0,0,0,232.958,96Zm-15.5,10.8h6.6v2.54h-6.6Zm11.94,9.272h-11.94v-2.54H229.4Z"
          transform="translate(-75.949 0)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_41"
          data-name="Path 41"
          d="M127.921,213.746V192h-1.689A1.231,1.231,0,0,0,125,193.257v25.925a1.242,1.242,0,0,0,1.232,1.27h18.634a1.231,1.231,0,0,0,1.219-1.27v-1.651h-14.4A3.757,3.757,0,0,1,127.921,213.746Z"
          transform="translate(0 -83.806)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_42"
          data-name="Path 42"
          d="M171.048,170.542V149h-1.829A1.235,1.235,0,0,0,168,150.283v25.925a1.2,1.2,0,0,0,1.219,1.245h18.634a1.231,1.231,0,0,0,1.245-1.245v-1.8H174.884A3.887,3.887,0,0,1,171.048,170.542Z"
          transform="translate(-37.538 -46.268)"
          fill={fill ? fill : "#a07eff"}
        />
      </g>
    </svg>
  );
};

export default TopicContentIcon;
